module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "topo"
    }
  }, [_c('nav', {
    staticClass: "white",
    attrs: {
      "id": "nav"
    }
  }, [_c('div', {}, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('ul', {
    staticClass: " hide-on-med-and-down nav-regular right"
  }, [_vm._m(2), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "pdf-resume",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        _vm.AbreModal()
      }
    }
  }, [_c('img', {
    staticClass: "img-pdf",
    attrs: {
      "src": require(".././assets/img/pdf.svg")
    }
  }), _vm._v(" "), _c('bold', [_vm._v("PDF Resume Download")])], 1)]), _vm._v(" "), _vm._m(3), _vm._v(" "), _vm._m(4), _vm._v(" "), _vm._m(5), _vm._v(" "), _vm._m(6), _vm._v(" "), _vm._m(7)]), _vm._v(" "), _c('ul', {
    staticClass: "side-nav",
    attrs: {
      "id": "mobile-demo"
    }
  }, [_c('li', [_c('a', {
    staticClass: "waves-effect waves-light scrollSuave ",
    attrs: {
      "href": "#topo",
      "id": "startm"
    },
    on: {
      "click": function($event) {
        _vm.hide()
      }
    }
  }, [_c('i', {
    staticClass: "material-icons left material-icons-align left"
  }, [_vm._v("store")]), _vm._v("Home")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "waves-effect waves-light scrollSuave",
    attrs: {
      "href": "#topo"
    },
    on: {
      "click": function($event) {
        _vm.AbreModal()
      }
    }
  }, [_c('i', {
    staticClass: "material-icons left material-icons-align"
  }, [_vm._v("assignment_ind")]), _c('bold', [_vm._v("PDF Resume Download")])], 1)]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "waves-effect waves-light scrollSuave ",
    attrs: {
      "href": "https://linkedin.com/in/juscilan/",
      "id": "startm"
    },
    on: {
      "click": function($event) {
        _vm.hide()
      }
    }
  }, [_c('i', {
    staticClass: "material-icons left material-icons-align left"
  }, [_vm._v("phonelink")]), _vm._v("LinkedIn")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "waves-effect waves-light scrollSuave ",
    attrs: {
      "href": "http://twitter.com/juscilan",
      "id": "startm"
    },
    on: {
      "click": function($event) {
        _vm.hide()
      }
    }
  }, [_c('i', {
    staticClass: "material-icons left material-icons-align left"
  }, [_vm._v("portrait")]), _vm._v("Twitter")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "waves-effect waves-light scrollSuave ",
    attrs: {
      "href": "http://Github.com/juscilan",
      "id": "startm"
    },
    on: {
      "click": function($event) {
        _vm.hide()
      }
    }
  }, [_c('i', {
    staticClass: "material-icons left material-icons-align left"
  }, [_vm._v("receipt")]), _vm._v("Github")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "waves-effect waves-light scrollSuave ",
    attrs: {
      "href": "http://medium.com/@juscilan",
      "id": "startm"
    },
    on: {
      "click": function($event) {
        _vm.hide()
      }
    }
  }, [_c('i', {
    staticClass: "material-icons left material-icons-align left"
  }, [_vm._v("child_care")]), _vm._v("Medium")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "waves-effect waves-light scrollSuave",
    attrs: {
      "href": "#sobre"
    },
    on: {
      "click": function($event) {
        _vm.hide()
      }
    }
  }, [_c('i', {
    staticClass: "material-icons left material-icons-align"
  }, [_vm._v("face")]), _vm._v("About me")])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "brand"
  }, [_c('a', {
    staticClass: "scrollSuave brand-logo ",
    attrs: {
      "href": "#topo"
    }
  }, [_c('img', {
    staticClass: "circle bordabranca img-width",
    attrs: {
      "src": require(".././assets/img/juscilan.jpeg"),
      "alt": "Juscilan Moreto",
      "title": "Juscilan Moreto"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "button-collapse",
    attrs: {
      "href": "#",
      "data-activates": "mobile-demo"
    }
  }, [_c('i', {
    staticClass: "material-icons hamburguer",
    staticStyle: {
      "font-size": "48px"
    }
  }, [_vm._v("menu")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    staticClass: "scrollSuave",
    attrs: {
      "href": "#topo",
      "id": "start"
    }
  }, [_vm._v("Home")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    attrs: {
      "href": "https://linkedin.com/in/juscilan/",
      "id": "start"
    }
  }, [_vm._v("LinkedIn")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    attrs: {
      "href": "http://twitter.com/juscilan",
      "id": "start"
    }
  }, [_vm._v("Twitter")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    attrs: {
      "href": "http://Github.com/juscilan",
      "id": "start"
    }
  }, [_vm._v("Github")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    attrs: {
      "href": "http://medium.com/@juscilan",
      "id": "start"
    }
  }, [_vm._v("Medium")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    staticClass: "scrollSuave",
    attrs: {
      "href": "#sobre"
    }
  }, [_vm._v("About me ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d8e537e2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/jm-a-nav.vue
// module id = 424
// module chunks = 1